/** "Your development" (screens §A2): the released `teamFeedback` items as cards. Levels never appear. */
import type { ResponseOf } from "@bsim/contracts";
import { GxCard } from "../theme/primitives";
import { GxPill } from "../theme/GxPill";
import { FEEDBACK_HELD, FEEDBACK_HELD_SOLO } from "./copy";

type Feedback = ResponseOf<"teamFeedback">;

const roundLabel = (round: number): string => (round === 0 ? "Practice round" : `Round ${round}`);

export function Development({ feedback, solo = false }: { readonly feedback: Feedback; readonly solo?: boolean }) {
  if (!feedback.released) return <p className="gx-ci-held gx-muted" data-testid="check.feedbackHeld">{solo ? FEEDBACK_HELD_SOLO : FEEDBACK_HELD}</p>;
  return (
    <section className="gx-ci-development" data-testid="check.development" aria-labelledby="gx-ci-dev-h">
      <h2 className="gx-h1" id="gx-ci-dev-h">Your development</h2>
      <div className="gx-ci-dev-list">
        {feedback.items.map((it, i) => (
          <GxCard key={`${it.round}-${i}`} className="gx-ci-dev-card" testId={`check.feedback.${i}`}>
            <div className="gx-ci-dev-meta">
              <GxPill tone={it.kind === "strength" ? "good" : "gold"}>{it.kind === "strength" ? "Strength" : "Growth area"}</GxPill>
              <span className="gx-eyebrow">{roundLabel(it.round)}</span>
            </div>
            <p className="gx-ci-dev-behavior">{it.citedBehavior}</p>
            <dl className="gx-ci-dev-why">
              <div><dt>Why it matters</dt><dd>{it.whyItMatters}</dd></div>
              <div><dt>Try next time</dt><dd>{it.tryNextTime}</dd></div>
            </dl>
            <p className="gx-ci-dev-reflect">{it.reflect}</p>
          </GxCard>
        ))}
      </div>
    </section>
  );
}
